import { Direction } from '@modules/common/types';
import { DashboardAddContentMenu } from '@modules/dashboard/components/DashboardAddContentMenu';
import { useDashboardStore } from '@modules/dashboard/store/useDashboardStore';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import { Box, Tooltip } from '@mui/material';
import { useState } from 'react';

interface AddDashboardContentButtonProps {
  rowID?: string;
  className?: string;
  onActive?: () => void;
  onInactive?: () => void;
  cellInsertDirection: Direction;
}

export function RowResizerAddContentButton({
  rowID,
  className,
  onActive,
  onInactive,
  cellInsertDirection,
}: AddDashboardContentButtonProps) {
  const [menuAnchor, setMenuAnchor] = useState<null | HTMLElement>(null);
  const isMenuOpen = Boolean(menuAnchor);
  const isUpdateDashboardInProgress = useDashboardStore(
    ({ visual }) => visual.isUpdateDashboardInProgress,
  );

  const openMenu = (event: React.MouseEvent<HTMLDivElement>) => {
    setMenuAnchor(event.currentTarget);
    setTimeout(() => onActive?.(), 20);
  };

  const closeMenu = () => {
    setMenuAnchor(null);
    onInactive?.();
  };

  return (
    <>
      <Tooltip title="Add row" arrow placement="top">
        <Box
          className={className}
          onMouseEnter={onActive}
          onMouseLeave={onInactive}
          sx={{
            position: 'absolute',
            top: '-2px',
            left: 20,
            opacity: isMenuOpen ? 1 : 0,
            zIndex: 99,
            cursor: 'pointer',
            lineHeight: 'normal',
            height: 'fit-content',
            display: 'flex',
            backgroundColor: 'transparent',
            pointerEvents: isUpdateDashboardInProgress ? 'none' : undefined,
          }}
          onClick={openMenu}
        >
          <AddCircleOutlineIcon
            fontSize="medium"
            color={isUpdateDashboardInProgress ? 'disabled' : 'primary'}
          />
        </Box>
      </Tooltip>
      <DashboardAddContentMenu
        rowID={rowID}
        isOpen={isMenuOpen}
        anchorEl={menuAnchor}
        onClose={closeMenu}
        shouldShowNewOptions={true}
        cellInsertDirection={cellInsertDirection}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
      />
    </>
  );
}
